<template>
  <v-card v-if="normalizedMessages.length" :color="currentColor" class="rounded-0 pl-2 py-1 d-flex align-center" flat
    :dark="currentSeverity != 1">
    <v-icon size="16" class="mr-2">
      {{ severityIcon }}
    </v-icon>
    <span class="flex-grow-1">
      {{ currentMessage.message }}
    </span>
    <template v-if="normalizedMessages.length > 1">
      <v-btn icon small class="mr-0 my-n1" @click="prevMessage">
        <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>
      <span>
        <small>{{ currentIndex + 1 }} / {{ normalizedMessages.length }}</small>
      </span>
      <v-btn icon small class="ml-0 my-n1" @click="nextMessage">
        <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "WarningBanner",
  props: {
    // Array of { severity: Number (1-5), message: String }
    warningMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    normalizedMessages() {
      const messages = this.warningMessages || [];
      return messages
        .map((m) => {
          if (m && typeof m === "object") {
            return {
              severity: Number(m.severity) || 1,
              message: m.message != null ? String(m.message) : "",
            };
          }
          // Fallback for legacy string usage
          return {
            severity: 3,
            message: String(m),
          };
        })
        .filter((m) => m.message);
    },
    currentMessage() {
      const messages = this.normalizedMessages;
      if (!messages.length) {
        return { severity: 1, message: "" };
      }
      const index = Math.min(this.currentIndex, messages.length - 1);
      return messages[index];
    },

    currentSeverity() {
      return this.currentMessage.severity;
    },

    currentColor() {
      switch (this.currentSeverity) {
        case 1:
          return "disabled lighten-1";
        case 2:
          return "primary";
        case 3:
          return "warning";
        case 4:
          return "error";
        case 5:
          return "error darken-1";
        default:
          return "warning";
      }
    },

    severityIcon() {
      switch (this.currentSeverity) {
        case 1:
          return "mdi-information-variant";
        case 2:
          return "mdi-information";
        case 3:
          return "mdi-alert";
        case 4:
          return "mdi-alert-octagon";
        case 5:
          return "mdi-alert-octagon";
        default:
          return "mdi-alert";
      }
    },
  },
  watch: {
    warningMessages() {
      const len = this.normalizedMessages.length;
      this.currentIndex = Math.min(this.currentIndex, Math.max(0, len - 1));
    },
  },
  methods: {
    nextMessage() {
      const len = this.normalizedMessages.length;
      if (len <= 1) return;
      this.currentIndex = (this.currentIndex + 1) % len;
    },
    prevMessage() {
      const len = this.normalizedMessages.length;
      if (len <= 1) return;
      this.currentIndex = (this.currentIndex - 1 + len) % len;
    },
  },
};
</script>
